<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "./assets/css/cssreset.css";
import "./assets/css/common.css";
import { handleGetLanguage } from "@/utils/utils";
export default {
  name: "App",
  data() {
    return {};
  },

  methods: {
    handleelectLang() {
      const lang = window.sessionStorage.getItem("lang");
      if (lang) {
        this.$i18n.locale = lang;
      } else {
        this.$i18n.locale = handleGetLanguage();
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.handleelectLang();
    });
  },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
